import {
  property,
  subclass
} from '@arcgis/core/core/accessorSupport/decorators';
import type { ThemeColor } from '../../jmkw/theme-color.type';
import { PseudoLayer, PseudoLayerProperties } from './pseudo-layer';
import type { JepLayer } from './jep-arcgis.types';
import { ThemeAwareMixin, ThemeAwareLayerInterface } from './theme-aware.mixin';

export interface ThemeAwarePseudoLayerProperties<
  T extends JepLayer & Partial<ThemeAwareLayerInterface>
> extends PseudoLayerProperties<T> {
  /** Initial theme when not yet synced */
  initialTheme?: ThemeColor;
  /** Chosen sync mode */
  themeSyncMode?: 'parent' | 'basemap' | 'none';
}

const ThemeAwarePseudoLayerBase = ThemeAwareMixin(
  PseudoLayer as unknown as new (...args: any[]) => PseudoLayer<any>
);

@subclass('jmkw.layers.ThemeAwarePseudoLayer')
export class ThemeAwarePseudoLayer<
    T extends JepLayer & Partial<ThemeAwareLayerInterface>
  >
  extends ThemeAwarePseudoLayerBase
  implements ThemeAwareLayerInterface
{
  constructor(props: ThemeAwarePseudoLayerProperties<T>) {
    super(props);
    if (props.initialTheme) this.currentTheme = props.initialTheme;
    if (props.themeSyncMode) (this as any).themeSyncMode = props.themeSyncMode;
  }

  override onThemeChange?(oldTheme: ThemeColor, newTheme: ThemeColor): void;
}
